import { createAction, handleActions } from "redux-actions";
import { takeLatest } from "redux-saga/effects";
import TYPE from "../../constant/TYPE";
import { createActionType, createRequestForAnsweringQuestions } from "../../utils/createRequest";
import {
  loadInitialQuestion,
  checkAnswer,
  loadQuestion,
  loadAIDiagnosisQuestion,
  loadQuestionList,
  checkAnswerForInspection
} from "../../api/questionAPI";
import useLaTexCode from "../../hooks/useLaTexCode";
import useLoading from '../../hooks/useLoading'

const SET = 'answeringQuestions.SET';
const SET_QUESTION = 'answeringQuestions.SET_QUESTION';
const SPLIT_QUESTION = 'answeringQuestions.SPLIT_QUESTION';
const SET_INPUT_TYPE = 'answeringQuestions.SET_INPUT_TYPE';
const SET_QUESTION_RETRY = 'answeringQuestions.SET_QUESTION_RETRY';
const NEXT_QUESTION = 'answeringQuestions.NEXT_QUESTION';
const CHANGE_QUESTION = 'answeringQuestions.CHANGE_QUESTION';
const CLEAR = 'answeringQuestions.CLEAR';

const [
  LOAD_INITIAL_QUESTION,
  LOAD_INITIAL_QUESTION_SUCCESS,
  LOAD_INITIAL_QUESTION_FAILURE
] = createActionType( 'answeringQuestions.LOAD_INITIAL_QUESTION' );

const [
  CHECK_ANSWER,
  CHECK_ANSWER_SUCCESS,
  // CHECK_ANSWER_FAILURE
] = createActionType( 'answeringQuestions.CHECK_ANSWER' );

const [
  LOAD_QUESTION,
  LOAD_QUESTION_SUCCESS,
  LOAD_QUESTION_FAILURE
] = createActionType( 'answeringQuestions.LOAD_QUESTION' );

const [
  LOAD_AI_DIAGNOSIS_QUESTION,
  LOAD_AI_DIAGNOSIS_QUESTION_SUCCESS,
  LOAD_AI_DIAGNOSIS_QUESTION_FAILURE
] = createActionType( 'answeringQuestions.LOAD_AI_DIAGNOSIS_QUESTION' );

const [
  LOAD_QUESTION_LIST,
  LOAD_QUESTION_LIST_SUCCESS,
  LOAD_QUESTION_LIST_FAILURE
] = createActionType( 'answeringQuestions.LOAD_QUESTION_LIST' );

const [
  CHECK_ANSWER_FOR_INSPECTION,
  CHECK_ANSWER_FOR_INSPECTION_SUCCESS,
  CHECK_ANSWER_FOR_INSPECTION_FAILURE
] = createActionType( 'answeringQuestions.CHECK_ANSWER_FOR_INSPECTION' );

const defaultState = {
  learningType : '',
  learningEntryType : '',
  stageCode : '',
  data : {},
  temporaryData : {},
  resultData : {},
  listData : [],
  answeringCount : 0,
  isAccentQuestionCount : false,
  exercise : [],
  answer : [],
  multipleAnswer: '',
  randomMultipleAnswer: [],
  objctExmpCn: '',
  answerIndex : 0,
  keypadType : '',
  isShowKeypad : true,
  isErase: false,
  inputType : [],
  isAnswer : false,
  isShowOXPopup : false,
  isShowNotEnteredAnswerPopup : false,
  isShowEntryPopup : false,
  isNextQuestion : false,
  timeOverLevel : 0,
  isShowTimeOverPopup : false,
  isShowRelayWrongAnswerPopup : false,
  isShowConceptCheckPlayer : false,
  conceptCheckRunningTime : 0,
  isFinishedConceptCheck : false,
  isShowAIMessagePopup : false,
  isShowEntryClosePopup : false,
  isResumeYn : false,
  cncpMeta: ''
};

const setAnsweringQuestionsAction = createAction( SET, payload => payload );
const loadInitialQuestionAction = createAction( LOAD_INITIAL_QUESTION, payload => payload );
const setQuestionAction = createAction( SET_QUESTION, payload => payload );
const splitQuestionAction = createAction( SPLIT_QUESTION, payload => payload );
const setInputTypeAction = createAction( SET_INPUT_TYPE, payload => payload );
const checkAnswerAction = createAction( CHECK_ANSWER );
const loadQuestionAction = createAction( LOAD_QUESTION, payload => payload );
const setQuestionRetryAction = createAction( SET_QUESTION_RETRY, payload => payload );
const loadAIDiagnosisQuestionAction = createAction( LOAD_AI_DIAGNOSIS_QUESTION, payload => payload );
const loadQuestionListAction = createAction( LOAD_QUESTION_LIST, payload => payload );
const checkAnswerForInspectionAction = createAction( CHECK_ANSWER_FOR_INSPECTION );
const nextQuestionAction = createAction( NEXT_QUESTION, payload => payload );
const changeQuestionAction = createAction( CHANGE_QUESTION, payload => payload );
const clearAnsweringQuestionsAction = createAction( CLEAR );

const loadInitialQuestionRequest = createRequestForAnsweringQuestions( LOAD_INITIAL_QUESTION, loadInitialQuestion );
const checkAnswerRequest = createRequestForAnsweringQuestions( CHECK_ANSWER, checkAnswer );
const loadQuestionRequest = createRequestForAnsweringQuestions( LOAD_QUESTION, loadQuestion );
const loadAIDiagnosisQuestionRequest = createRequestForAnsweringQuestions( LOAD_AI_DIAGNOSIS_QUESTION, loadAIDiagnosisQuestion );
const loadQuestionListRequest = createRequestForAnsweringQuestions( LOAD_QUESTION_LIST, loadQuestionList );
const checkAnswerForInspectionRequest = createRequestForAnsweringQuestions( CHECK_ANSWER_FOR_INSPECTION, checkAnswerForInspection );

const { getEndScope } = useLaTexCode();


function * answeringQuestionsSaga () {
  yield takeLatest( LOAD_INITIAL_QUESTION, loadInitialQuestionRequest );
  yield takeLatest( CHECK_ANSWER, checkAnswerRequest );
  yield takeLatest( LOAD_QUESTION, loadQuestionRequest );
  yield takeLatest( LOAD_AI_DIAGNOSIS_QUESTION, loadAIDiagnosisQuestionRequest );
  yield takeLatest( LOAD_QUESTION_LIST, loadQuestionListRequest );
  yield takeLatest( CHECK_ANSWER_FOR_INSPECTION, checkAnswerForInspectionRequest );

}

const setQuestionReducer = ( state, action ) => {
  const updatedState = {
    ...state,
    learningType : action.payload.learningType || state.learningType,
    learningEntryType : action.payload.learningEntryType || state.learningEntryType,
    stageCode : action.payload.stageCode || state.stageCode,
    isShowEntryPopup : ! state.answeringCount,
    conceptCheckRunningTime : defaultState.conceptCheckRunningTime,
    isFinishedConceptCheck : defaultState.isFinishedConceptCheck,
    isAccentQuestionCount : false,
    cncpMeta: action.payload.data?.cncpMeta || state.cncpMeta
  };

  switch ( action.payload.data.prgsCd ) {
    case TYPE.ANSWERING_QUESTIONS_PROGRESS.CONTINUE :
    case TYPE.ANSWERING_QUESTIONS_PROGRESS.DRILL_DOWN :
      if ( 'Y' === action.payload.data.prgsMsgYn ) {
        return {
          ...updatedState,
          temporaryData : action.payload.data,
          isShowAIMessagePopup : true
        };
      } else {
        return {
          ...updatedState,
          data : action.payload.data,
          answeringCount : action.payload?.resumeYn === 'Y' ? action.payload.data.estQstNowNo : updatedState.answeringCount + 1
        };
      }
    case TYPE.ANSWERING_QUESTIONS_PROGRESS.CONCEPT_CHECK :
      return {
        ...updatedState,
        temporaryData : action.payload.data,
        isShowRelayWrongAnswerPopup : true
      };
    case TYPE.ANSWERING_QUESTIONS_PROGRESS.COMPLETE :
    case TYPE.ANSWERING_QUESTIONS_PROGRESS.TOPIC_LEARNING_RECOMMENDATION_AND_COMPLETE :
    case TYPE.ANSWERING_QUESTIONS_PROGRESS.FALSENESS_COMPLETE :
      return {
        ...updatedState,
        resultData : action.payload.data
      };
  }

};

const splitQuestionReducer = ( state, action ) => {

  let answer = [];

  const mapExercise = ( value, index, origin ) => {
    const cssId = `${ TYPE.ID.ANSWER_AREA }${ index }}{`;
    if ( index ) {
      const startValue = value.slice( value.indexOf( '{' ) );
      const endPoint = getEndScope( startValue );
      answer = [ ...answer, `\\phantom{${ startValue.slice( 1, endPoint - 1 ) }}` ];
      return `${ startValue.slice( endPoint - 1 ) }${ origin.length === index + 1 ? '' : cssId }`;
    } else {
      return 1 === origin.length ? value : `${ value }${ cssId }`;
    }
  };

  return {
    ...state,
    exercise : action.payload ? action.payload.split( 'inputArea' ).map( mapExercise ) : [],
    answer : answer,
    answerIndex : 0
  };

};

const setInputTypeReducer = ( state, action ) => {

  return {
    ...state,
    inputType : -1 === state.inputType.indexOf( action.payload ) ? [ ...state.inputType, action.payload ] : state.inputType
  };

};

const checkAnswerSuccessReducer = ( state, action ) => {
  console.log(`***** 채점 결과: ${'Y' === action.payload.checkYn ? "정답" : "틀림"}`)

  return {
    ...state,
    isAnswer : 'Y' === action.payload.checkYn,
    isShowOXPopup : true
  };

};

const setQuestionRetryReducer = ( state, action ) => {

  return {
    ...setQuestionReducer( state, {
      payload : {
        data : {
          ...state.temporaryData,
          prgsCd : TYPE.ANSWERING_QUESTIONS_PROGRESS.CONTINUE,
          prgsMsgYn : 'N'
        }
      }
    } ),
    ...action.payload,
    isAccentQuestionCount : 'Y' === state.temporaryData.prgsMsgYn
  };

};

const loadAIDiagnosisQuestionSuccessReducer = ( state, action ) => {

  switch ( action.payload.prgsCd ) {
    case TYPE.ANSWERING_QUESTIONS_PROGRESS.CONTINUE :
      return {
        ...state,
        data : action.payload
      };
    case TYPE.ANSWERING_QUESTIONS_PROGRESS.COMPLETE :
      return {
        ...state,
        resultData : action.payload
      };
  }

};

const loadQuestionListSuccessReducer = ( state, action ) => {
  if ( action.payload.qstispList.length ) {
    const listData = action.payload.qstispList.map( v => ( { ...v, stgNm : action.payload.stgNm } ) );
    return {
      ...state,
      data : listData[ 0 ],
      answeringCount : 1,
      listData
    };
  } else {
    return state;
  }

};

const checkAnswerForInspectionSuccessReducer = ( state, action ) => {

  return {
    ...state,
    isAnswer : 'Y' === action.payload.checkYn,
    isShowOXPopup : true
  };

};

const nextQuestionReducer = ( state ) => {
  const updatedState = {
    ...state,
    isShowOXPopup : false
  };

  if ( state.listData.length === state.answeringCount ) {
    return {
      ...updatedState,
      resultData : { prgsCd : TYPE.ANSWERING_QUESTIONS_PROGRESS.COMPLETE }
    };
  } else {
    return {
      ...updatedState,
      data : state.listData.filter( ( v, i ) => state.answeringCount === i )[ 0 ],
      answeringCount : state.answeringCount + 1
    };
  }

};

const changeQuestionReducer = ( state, action ) => {
  let questionIndex;

  const filterList = ( value, index ) => {
    if ( action.payload === value.qstCd ) {
      questionIndex = index;
      return true;
    } else {
      return false;
    }
  };

  return {
    ...state,
    data : state.listData.filter( filterList )[ 0 ],
    answeringCount : questionIndex + 1
  };
};

const consoleFormatting = (type, state, action) => {
  console.log(`### ${type}: 
  ## state: ${JSON.stringify(state)}
  ## action: ${JSON.stringify(action)}
  `)
}

const answeringQuestions = handleActions( {
  [ SET ] : ( state, action ) => ( { ...state, ...action.payload } ),
  [ LOAD_INITIAL_QUESTION_SUCCESS ] : setQuestionReducer,
  [ LOAD_INITIAL_QUESTION_FAILURE ] : (state, action) => (consoleFormatting('LOAD_INITIAL_QUESTION_FAILURE', state, action)),
  [ SET_QUESTION ] : setQuestionReducer,
  [ SPLIT_QUESTION ] : splitQuestionReducer,
  [ SET_INPUT_TYPE ] : setInputTypeReducer,
  [ CHECK_ANSWER_SUCCESS ] : checkAnswerSuccessReducer,
  // [ CHECK_ANSWER_FAILURE ] : console.log,
  [ LOAD_QUESTION_SUCCESS ] : setQuestionReducer,
  [ LOAD_QUESTION_FAILURE ] : (state, action) => (consoleFormatting('LOAD_QUESTION_FAILURE', state, action)),
  [ SET_QUESTION_RETRY ] : setQuestionRetryReducer,
  [ LOAD_AI_DIAGNOSIS_QUESTION_SUCCESS ] : loadAIDiagnosisQuestionSuccessReducer,
  [ LOAD_AI_DIAGNOSIS_QUESTION_FAILURE ] : (state, action) => (consoleFormatting('LOAD_AI_DIAGNOSIS_QUESTION_FAILURE', state, action)),
  [ LOAD_QUESTION_LIST_SUCCESS ] : loadQuestionListSuccessReducer,
  [ LOAD_QUESTION_LIST_FAILURE ] : (state, action) => (consoleFormatting('LOAD_QUESTION_LIST_FAILURE', state, action)),
  [ CHECK_ANSWER_FOR_INSPECTION_SUCCESS ] : checkAnswerForInspectionSuccessReducer,
  [ CHECK_ANSWER_FOR_INSPECTION_FAILURE ] :  (state, action) => (consoleFormatting('CHECK_ANSWER_FOR_INSPECTION_FAILURE', state, action)),
  [ NEXT_QUESTION ] : nextQuestionReducer,
  [ CHANGE_QUESTION ] : changeQuestionReducer,
  [ CLEAR ] : () => defaultState
}, defaultState );

export default answeringQuestions;
export {
  LOAD_INITIAL_QUESTION,
  CHECK_ANSWER,
  LOAD_QUESTION,
  LOAD_AI_DIAGNOSIS_QUESTION,
  LOAD_QUESTION_LIST,
  setAnsweringQuestionsAction,
  loadInitialQuestionAction,
  setQuestionAction,
  splitQuestionAction,
  setInputTypeAction,
  checkAnswerAction,
  loadQuestionAction,
  setQuestionRetryAction,
  loadAIDiagnosisQuestionAction,
  loadQuestionListAction,
  nextQuestionAction,
  changeQuestionAction,
  checkAnswerForInspectionAction,
  clearAnsweringQuestionsAction,
  answeringQuestionsSaga
};
